import React, { useState, useEffect } from "react";
import bg from "../../../../assets/images/wifi-squeeze/bg.jpg";
import logo from "../../../../assets/images/wifi-squeeze/logo.png";
import SafetyApp from "../../../../assets/images/wifi-squeeze/SafetyApp.png";
import toy3 from "../../../../assets/images/wifi-squeeze/toy3.png";
import toy4 from "../../../../assets/images/wifi-squeeze/toy4.png";
import logo2 from "../../../../assets/images/wifi-squeeze/logo2.png";
import talk from "../../../../assets/images/wifi-squeeze/talk.png";
import scaner from "../../../../assets/images/wifi-squeeze/scaner.png";
import price from "../../../../assets/images/wifi-squeeze/price.png";
import success from "../../../../assets/images/wifi-squeeze/success.png";
import qrcode from "../../../../assets/images/wifi-squeeze/qr_code.jpeg";
import { fetchData } from "../../../../services";
import { useParams } from "react-router-dom";
import PageLoader from "../../../util/PageLoader";

const RANDOMTEXTS = [
  "2000+ people have played this week",
  "Over 10,000 downloads already",
  "5,000 players joined last month",
  "1,200 check-ins today",
  "75+ prizes claimed this week",
  "3,000 daily active players",
  "Over 200 local businesses involved",
  "90% of players recommend to a friend",
  "4.9★ average rating from users",
  "John just won a free prize",
  "Sarah unlocked today’s clue",
  "Liam claimed 500 points",
  "Mia checked in at Surfers Paradise",
  "Ethan hit the leaderboard",
  "Ava just scanned a QR and won",
  "Noah grabbed today’s reward",
  "Chloe finished the hunt in Broadbeach",
  "Lucas scored double points",
];

function WifiSqueezeSuccess() {
  const { id } = useParams();
  const [items, setItems] = useState({});
  const [loading, setLoading] = useState(true);
  const [text, setText] = useState("");

  const getItemsDetails = async () => {
    setLoading(true);
    const resp = await fetchData(`getHotelWifiSqueeze/${id}`);
    if (resp?.type === "success") {
      setItems(resp?.payload);
      setLoading(false);
    }
  };

  useEffect(() => {
    getItemsDetails();
  }, []);

  
  useEffect(() => {
    // function to get random text
    const getRandomText = () =>
      RANDOMTEXTS[Math.floor(Math.random() * RANDOMTEXTS.length)];

    // set initial text
    setText(getRandomText());

    // change text every 15 seconds
    const interval = setInterval(() => {
      setText(getRandomText());
    }, 7000);

    // cleanup
    return () => clearInterval(interval);
    
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  return (
    <>
      <div
        className="outerWrapper_wifi"
        style={{
          background: `url(${items?.background_image}) no-repeat center center / cover`,
        }}
      >
        <header style={{ backgroundColor: items?.header_color }}>
          <img className="logo1" src={items.logo} alt="Logo" />
          <img className="logo2" src={SafetyApp} alt="SafetyApp" />
        </header>

        <div className="wifi-box box2">
          <div className="priceWrap">
            {/* Left Side */}
            <div className="priceLeft">
              <h2>You’re connected, Play For Prizes</h2>

              <div className="priceImgWrap">
                {/* Big Images */}
                <div className="bigImg">
                  <div className="topImg">
                    <figure>
                      <img src={bg} alt="" />
                      <div className="caption">
                        <h2>Grand Prize</h2>
                        <h3>Tandem Skysive</h3>
                      </div>
                    </figure>
                  </div>

                  <div className="bottomImg">
                    <div className="bottomLeft">
                      <figure>
                        <img src={bg} alt="" />
                        <div className="caption">
                          <h2>
                            2<sup>nd</sup> Prize
                          </h2>
                          <h3>Romantic Dinner</h3>
                        </div>
                      </figure>
                    </div>

                    <div className="bottomRight">
                      <figure>
                        <img src={bg} alt="" />
                        <div className="caption">
                          <h2>
                            3<sup>nd</sup> Prize
                          </h2>
                          <h3>Jetboat ride</h3>
                        </div>
                      </figure>
                    </div>
                  </div>
                </div>

                {/* Small Images */}
                <div className="smallImg">
                  <h4>Guaranteed Daily Prizes</h4>
                  <div className="boxWrap">
                    <div className="box_wrapper">
                      <div className="box">
                        <div className="top">
                          <div className="num">
                            <h2 className="circle">3</h2>
                          </div>
                          <div className="text">check-In YOU GET</div>
                        </div>
                        <div className="imgWrap">
                          <img className="toy3" src={toy3} alt="" />
                        </div>
                      </div>
                      <div className="bottom">FREE Sunny magnet</div>
                    </div>

                    <div className="box_wrapper">
                      <div className="box">
                        <div className="top">
                          <div className="num">
                            <h2 className="circle">5</h2>
                          </div>
                          <div className="text">check-In YOU GET</div>
                        </div>
                        <div className="imgWrap">
                          <img className="toy4" src={toy4} alt="" />
                        </div>
                      </div>
                      <div className="bottom">FREE Sunny magnet</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="priceRight">
              <button type="button" className="desktop-img getstart">
                Get Started Now
              </button>
              {/* <p>2000 + have played this week</p> */}
              <p><strong>{text}</strong></p>

              <div className="largeDevice_scanner">
                <img className="desktop-img scanner" src={success} alt="" />
                <img className="qrcode" src={qrcode} alt="" />
              </div>
              <img className="mobile-img scanner" src={price} alt="" />

              <div className="desktop-img appDownlaod">
                Scan to download the app
              </div>
              <div className="desktop-img time">
                Takes 30 sec - Next prize draw: Friday 3.00PM
              </div>
              <div className="desktop-img altmsg">
                Can’t scan? enter your mobile number and we’ll text you the app
              </div>

              <div className="desktop-img formWrap">
                <div className="phoneNum">
                  <input type="text" className="form-control" />
                  <button type="button" className="submit">
                    Submit
                  </button>
                </div>
              </div>

              <div className="desktop-img privacy">
                We respect your privacy. Your details won’t be shared. No spam
              </div>
              <img src={logo2} className="logo2" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WifiSqueezeSuccess;
